import { useContext, useEffect, useState } from "react";
import colors from "./colors";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { AuthContext } from "core/contexts/auth/auth";
import { useNavigate } from "react-router";
import { useAppTheme } from "core/contexts/theme/theme";
import { TagTitleP } from "./home.styled";
import { Paper } from "@mui/material";
import { t } from "i18next";
import { v4 as uuid4 } from "uuid";
import { navigateToPath } from "core/utils/common";
import { HeaderTitle, LinkButton } from "./filteredItem.styled";
import { Toast as showToast } from "core/components/global/toast/toast";
import { styled } from "styled-components";


const FilteredItemButton = styled.button`
  color: white !important;
`;

export const FilteredItemList = ({
  index,
  filteredItem,
  favorites,
  handleChatNavigation,
  updateFavoritesState,
  handleSetActiveModel,
  type,
}) => {
  const navigate = useNavigate();
  const [heart, setHeart] = useState(false);
  const [header, setHeader] = useState("");
  const { apptheme } = useAppTheme();

  // Check if this item is in favorites
  const isInFavorites = () => {
    // Safety check against null/undefined favorites or filteredItem
    if (!favorites || !filteredItem) return false;
    return favorites?.some((provider) => provider.targetName === filteredItem.state) || false;
  };

  // Handle clicking the heart icon
  const handleUpdateFavoritesState = async (target) => {
    // Safety check against null/undefined target
    if (!target) {
      console.error("Target is null or undefined in handleUpdateFavoritesState");
      showToast("Unable to update favorites. Invalid item selected.", "error");
      return;
    }
    
    // Toggle the heart state immediately for visual feedback
    setHeart(!heart);
    
    // Then update the backend
    try {
      const result = await updateFavoritesState(target);
      
    } catch (error) {
      console.error("Error updating favorites state:", error);
      // Revert the heart state if there's an error
      setHeart(heart);
      showToast("Failed to update favorites. Please try again later.", "error");
    }
  };

  function resetLocalHeader(item) {
    let value;

    if (item.sidebarProps.showRawText === true) {
      value = item.sidebarProps.displayText
    } else {
      value = t(`SIDEBAR.${item.sidebarProps.displayText}`);
    }

    setHeader(value);
  }

  // Set the initial state based on favorites
  useEffect(() => {
    setHeart(isInFavorites())

    if (filteredItem) {
      resetLocalHeader(filteredItem);
    }
  }, []);

  // Keep heart state in sync with favorites
  useEffect(() => {
    setHeart(isInFavorites());

    if (filteredItem) {
      resetLocalHeader(filteredItem);
    }
  }, [favorites, filteredItem?.state]);

  let jsxBody = <></>;

  if (filteredItem !== null) {
    if (type === "list") {
      return(
        <Paper
          elevation={1}
          key={filteredItem.state}
          className="card-list flex items-center rounded-lg ps-4 pb-3 pe-3"
        >
          <div className="flex-1">
            <h3 className="font-semibold" style={{ color: colors.deepDark, fontSize: apptheme.font.xl }}>
              {header}
            </h3>

            <p className="text-sm" style={{ color: colors.textSecondary }}>
              {filteredItem.sidebarProps.description}
            </p>

            <div className="mt-2 flex flex-wrap gap-1">
              {filteredItem.sidebarProps.tags &&
                filteredItem.sidebarProps.tags.map((tag) => (
                  <span
                    key={tag}
                    className="filter-tag px-2 py-0.5 rounded text-xs"
                    style={{
                      color: colors.deepDark,
                    }}
                  >
                    {tag}
                  </span>
                ))}
            </div>
          </div>

          <div className="flex items-center space-x-3 justify-end">
            {filteredItem.path.includes("/console/soon") ? (
              <TagTitleP>Coming Soon</TagTitleP>
            ) : filteredItem.path.includes("/console/chat") ? (
              <FilteredItemButton
                className="px-3 py-1 rounded-md text-sm font-medium transition-colors text-white"
                style={{ backgroundColor: '#A100FF' }}
                onClick={() => {
                  handleChatNavigation(filteredItem.sidebarProps.displayText);
                }}
              >
                Run Model
              </FilteredItemButton>
            ) : (
              filteredItem.path.includes("http") ? (
                <FilteredItemButton
                  className="px-3 py-1 rounded-md text-sm font-medium transition-colors text-white"
                  style={{ backgroundColor: '#A100FF' }}
                  onClick={() => {
                    navigateToPath(
                      navigate, 
                      filteredItem,
                      handleSetActiveModel
                    )
                  }}
                >
                  Navigate Site
                </FilteredItemButton>
              ) : (
                <FilteredItemButton
                  className="px-3 py-1 rounded-md text-sm font-medium transition-colors text-white"
                  style={{ backgroundColor: '#A100FF' }}
                  onClick={() => {
                    navigateToPath(
                      navigate, 
                      filteredItem,
                      handleSetActiveModel
                    )
                  }}
                >
                  Visit Site
                </FilteredItemButton>
              )
            )}

            {favorites !== null && favorites.length > 0 && heart === true ? (
              <button
                title="Remove from favorites"
                onClick={() => {
                  handleUpdateFavoritesState(filteredItem.state);
                }}
              >
                <FavoriteIcon style={{ color: "red" }} sx={{ fontSize: 18 }} />
              </button>
            ) : (
              <button
                onClick={() => {
                  handleUpdateFavoritesState(filteredItem.state);
                }}
                title="Add to favorites"
              >
                <FavoriteBorderIcon sx={{ fontSize: 18 }} />
              </button>
            )}
          </div>
        </Paper>
      )
    } else {
      return(
        <Paper
          elevation={1}
          key={filteredItem.state}
          className="card rounded-lg transition-all duration-300 ease-in-out"
        >
          <div
            className="card-header d-flex justify-space-between"
            style={{ border: "none" }}
          >
            <HeaderTitle className="font-semibold flex-1">
              {header}
            </HeaderTitle>
            {favorites !== null && favorites.length > 0 && heart === true ? (
              <button
                className="hover:text-yellow-500 transition-colors"
                title="Remove from favorites"
                onClick={() => {
                  handleUpdateFavoritesState(filteredItem.state);
                }}
              >
                <FavoriteIcon style={{ color: "red" }} sx={{ fontSize: 18 }} />
              </button>
            ) : (
              <button
                className="hover:text-yellow-500 transition-colors"
                onClick={() => {
                  handleUpdateFavoritesState(filteredItem.state);
                }}
                title="Add to favorites"
              >
                <FavoriteBorderIcon sx={{ fontSize: 18 }} />
              </button>
            )}
          </div>

          <div className="card-body py-3">
            <p>{filteredItem.sidebarProps.description}</p>

            <div className="mt-3 flex flex-wrap gap-2">
              {filteredItem.sidebarProps.tags &&
                filteredItem.sidebarProps.tags.map((tag) => (
                  <span
                    key={tag}
                    className={`filter-tag px-2 py-0.5 rounded text-xs bg-[${apptheme.colors.buttonchipcolor}]`}
                  >
                    {tag}
                  </span>
                ))}
            </div>
          </div>

          <div
            className="card-footer"
            style={{
              borderColor: colors.mediumLightPurple,
            }}
          >
            <div
              className="py-2 flex justify-end"
              style={{
                borderColor: colors.mediumLightPurple,
                float: "right"
              }}
            >
              {filteredItem.path.includes("/console/soon") ? (
                <TagTitleP className="fst-italic">Coming Soon</TagTitleP>
              ) : filteredItem.path.includes("/console/chat") ? (
                <LinkButton
                  className="text-sm font-medium transition-colors"
                  onClick={() => {
                    handleChatNavigation(filteredItem.sidebarProps.displayText);
                  }}
                >
                  Run Model
                </LinkButton>
              ) : filteredItem.path.includes("/console/") ? (
                <LinkButton
                  className="text-sm font-medium transition-colors"
                  onClick={() => {
                    handleChatNavigation(filteredItem.sidebarProps.displayText);
                  }}
                >
                  Visit Site
                </LinkButton>
              ) : (
                filteredItem.path.includes("http") && (
                  <LinkButton
                    className="text-sm font-medium transition-colors"
                    onClick={() => {
                      navigateToPath(
                        navigate, 
                        filteredItem,
                        handleSetActiveModel
                      )
                    }}
                  >
                    Navigate site
                  </LinkButton>
                )
              )}
            </div>
          </div>
        </Paper>
      );
    }
  } else {
    return(<div key={uuid4()}></div>);
  }
};